import { calendarReducerConstant } from "../reducerConstant";

const initialState = {
  timezoneList: [],
  bookingPeriodList: [
    "1 Week",
    "2 Weeks",
    "3 Weeks",
    "4 Weeks",
    "2 Months",
    "3 Months",
  ],
  calendarScheduleInfo: {
    timezoneId: "",
    bookingPeriod: "",
    noticePeriodNum: "",
    noticePeriod: "Days",
    scheduleDays: [],
    unavailableDays: [],
  },
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case calendarReducerConstant.SET_TIMEZONE_LIST:
      return {
        ...state,
        timezoneList: action.payload,
      };
    case calendarReducerConstant.SET_CALENDARSCHEDULE_INFO:
      return {
        ...state,
        calendarScheduleInfo: { ...action.payload },
      };
    default:
      return state;
  }
};

export default calendarReducer;
